module.exports = __webpack_public_path__ + "img/linkedin.d142adfc.png";